import { render } from "./vueAlert.vue?vue&type=template&id=5f4577ca&scoped=true"
import script from "./vueAlert.vue?vue&type=script&lang=js"
export * from "./vueAlert.vue?vue&type=script&lang=js"

import "./vueAlert.vue?vue&type=style&index=0&id=5f4577ca&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4577ca"]])

export default __exports__